import { useParams } from 'react-router-dom';
import ResetPasswordFormPage from './ResetPasswordFormPage';

const ResetPasswordPage = () => {
  const { token } = useParams();

  return <ResetPasswordFormPage token={token} />;
};

export default ResetPasswordPage;
